import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Check, SkipForward } from "lucide-react";

export const WorkoutPlayer = ({ accessId, task, onClose }) => {
  const d = task.detail || {};
  const exercises = d.exercises || [];
  const [idx, setIdx] = useState(0);
  const [logs, setLogs] = useState({});
  const ex = exercises[idx];

  const setLog = (field, val) => setLogs((l) => ({ ...l, [idx]: { ...(l[idx] || {}), [field]: val } }));

  const finish = async () => {
    const sets = exercises.map((e, i) => ({ name: e.name, ...(logs[i] || {}) }));
    await api.post(`/programs/${accessId}/workout/log`, { week_number: task.week_number, day_index: task.day_index, task_id: task.id, sets, duration_min: d.duration_min });
    toast.success("Workout logged — strong work.");
    onClose();
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass-strong border-white/10 max-w-md" data-testid="workout-player">
        <DialogHeader><DialogTitle className="font-serif text-xl text-white">{d.name}</DialogTitle></DialogHeader>
        <div className="text-[11px] font-mono text-slate-500">Exercise {idx + 1} of {exercises.length} · {d.duration_min} min</div>
        {ex && (
          <div className="glass rounded-xl p-5 mt-2" data-testid={`player-exercise-${idx}`}>
            <div className="serif-display text-2xl text-white">{ex.name}</div>
            <div className="text-sm text-cyan-300 font-mono mt-1">{ex.sets} sets × {ex.reps}{ex.rpe ? ` · RPE ${ex.rpe}` : ""}</div>
            <div className="text-[11px] text-slate-500 mt-1">{ex.muscle} · {ex.equipment}</div>
            <div className="grid grid-cols-2 gap-2 mt-4">
              <Input placeholder="Weight" onChange={(e) => setLog("weight", e.target.value)} className="bg-black/40 border-white/10" data-testid="log-weight" />
              <Input placeholder="Reps done" onChange={(e) => setLog("reps", e.target.value)} className="bg-black/40 border-white/10" data-testid="log-reps" />
            </div>
          </div>
        )}
        <div className="flex gap-2 mt-3">
          <Button variant="outline" onClick={() => setIdx((i) => Math.min(exercises.length - 1, i + 1))} disabled={idx >= exercises.length - 1} data-testid="player-skip"><SkipForward size={14} className="mr-1" /> Next</Button>
          {idx < exercises.length - 1 ? (
            <Button onClick={() => setIdx((i) => i + 1)} className="btn-primary rounded-lg flex-1" data-testid="player-complete-set"><Check size={14} className="mr-1" /> Complete set</Button>
          ) : (
            <Button onClick={finish} className="btn-primary rounded-lg flex-1" data-testid="player-finish"><Check size={14} className="mr-1" /> Finish workout</Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
